"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FormComponent = /*#__PURE__*/function () {
  function FormComponent() {
    var _this = this;
    _classCallCheck(this, FormComponent);
    this.init();
    this.initNetteFormValidation();

    // AJAX FORM SENT
    $.nette.ext("genericFormAjax", {
      before: function before(jqXHR, settings) {
        $(settings.nette.el).addClass("sending");
      },
      complete: function complete(jqXHR, status, settings) {
        _this._fieldsVisible = false;
        $(settings.nette.el).removeClass("sending");
      }
    });
  }

  /**
   * Nette Form Validation
   */
  _createClass(FormComponent, [{
    key: "initNetteFormValidation",
    value: function initNetteFormValidation() {
      Nette.showFormErrors = function (form, errors) {
        var validationType = $(form).attr("data-validationtype");

        // REMOVE ALL ERRORS FROM FORM
        $("label.error", form).removeClass("error");
        $(".error-text", form).remove();
        switch (validationType) {
          case "fields":
            errors.forEach(function (error) {
              var field = $(error.element, form);
              var label = field.parent("label");
              label.addClass("error"); // SET STYLE AS INVALID FIELD

              // ADD ERROR MESSAGE TO FIELD
              label.append("<span class='error-text'>" + error.message + "</span>");
            });
        }
      };
    }
  }, {
    key: "init",
    value: function init() {}
  }]);
  return FormComponent;
}();